var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadmsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0429 18.5313C13.6524 18.1408 13.6524 17.5076 14.0429 17.1171L18.3358 12.8242L14.0429 8.53133C13.6524 8.1408 13.6524 7.50764 14.0429 7.11711C14.4334 6.72659 15.0666 6.72659 15.4571 7.11711L20.4571 12.1171C20.8476 12.5076 20.8476 13.1408 20.4571 13.5313L15.4571 18.5313C15.0666 18.9218 14.4334 18.9218 14.0429 18.5313Z",
    fill: "#C4C7C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 12.8242C20.75 13.3765 20.3023 13.8242 19.75 13.8242L11.75 13.8242C5.67472 13.8242 0.75 8.8995 0.75 2.82422V1.82422C0.75 1.27193 1.19772 0.824219 1.75 0.824219C2.30228 0.824219 2.75 1.27193 2.75 1.82422V2.82422C2.75 7.79493 6.77929 11.8242 11.75 11.8242H19.75C20.3023 11.8242 20.75 12.2719 20.75 12.8242Z",
    fill: "#C4C7C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadmsg);
export default __webpack_public_path__ + "static/media/unreadmsg.7b67b4f8afdae6e2b95fac0c589d8844.svg";
export { ForwardRef as ReactComponent };